import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { shortenHash } from '@soundxyz/utils/const';
import { FollowButton } from '@components/basics/FollowButton';
import { Avatar } from '@components/basics/Images/Avatar';
import {
  FeedRecommendedFollowsUserCellFragmentDoc,
  type FragmentType,
  getFragment,
} from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment FeedRecommendedFollowsUserCell on User {
    id
    webappUri
    publicAddress
    username
    avatar {
      id
      url
    }
  }
`);

const IMAGE_SIZE = 40;

export function FeedRecommendedFollowsUserCell({
  userFrag,
}: {
  userFrag: FragmentType<FeedRecommendedFollowsUserCellFragmentDoc>;
}) {
  const user = getFragment(FeedRecommendedFollowsUserCellFragmentDoc, userFrag);

  const { id: userId, webappUri, publicAddress: walletAddress, username, avatar } = user;

  return (
    <div className="flex flex-col items-center gap-2 lt:flex-row">
      <div className="aspect-square h-10 w-10 overflow-hidden rounded-full bg-neutral100">
        <Avatar
          webappUri={webappUriPath(webappUri)}
          username={username}
          walletAddress={walletAddress}
          src={avatar?.url}
          size={IMAGE_SIZE}
          borderRadius={999}
        />
      </div>
      <div className="flex flex-1 flex-col gap-0.5">
        <div className="font-title text-title-xxs font-medium text-base600">{username}</div>
        <div className="text-base-xs font-medium text-base500">{shortenHash(walletAddress)}</div>
      </div>
      <FollowButton
        size="XS"
        sourceLocation="Activity Feed Recommended Following"
        userId={userId}
      />
    </div>
  );
}
